import chatImg from "/assets/images/advantages/webp/chat.webp";
import customizeImg from "/assets/images/advantages/webp/customize.webp";
import customizeImgMobile from "/assets/images/advantages/webp/customizeMobile.webp";
import insightsImg from "/assets/images/advantages/webp/insights.webp";
import videoToTextImg from "/assets/images/advantages/webp/videoToText.webp";
import videoToTextImgMobile from "/assets/images/advantages/webp/videoToTextMobile.webp";
import type { IAdvantages } from "../config";

export const advantagesMock: IAdvantages = {
  title: "Unlock the ultimate toolkit for mastering any video",
  subtitle: "Save time and focus on insights that matter most.",
  advantagesItems: [
    {
      utilClasses: "col-span-7 mobile:col-span-12",
      title: "AI-powered insights",
      desc: <>Transform long videos into clear, <br />actionable key points</>,
      img: {
        alt: "insights",
        desktop: insightsImg,
      },
    },
    {
      utilClasses: "col-span-5 mobile:col-span-12",
      title: "Video to text",
      desc: "Access high-quality transcriptions that outperform standard YouTube captions",
      img: {
        alt: "videoToText",
        desktop: videoToTextImg,
        mobile: videoToTextImgMobile,
      },
    },
    {
      utilClasses: "col-span-5 mobile:col-span-12",
      title: "Customize your experience",
      desc: "by adjusting the content and length of your summary",
      img: {
        alt: "customize",
        desktop: customizeImg,
        mobile: customizeImgMobile,
      },
    },
    {
      utilClasses: "col-span-7 mobile:col-span-12",
      title: "Chat with video content",
      desc: <>Ask questions directly about the video <br />and cut through the noise</>,
      img: {
        alt: "chat",
        desktop: chatImg,
      },
    },
  ],
};
